(function($) {
    var numSlick = 0;
    $('.slider-container').each( function() {
        numSlick++;

        // Leader slider
        $(this).find('.slider-tabs').addClass( 'slider-' + numSlick ).slick({
            arrows: false,
            asNavFor: '.slider-tabs-nav',
            fade: true,
            infinite: false,
            slide: '.slider-item',
            slidesToScroll: 1,
            slidesToShow: 1,
        });

        var tabsNav = $(this).find('.slider-tabs-nav').addClass( 'slider-' + numSlick ),
            tabCount = tabsNav.data('count'),
            slidesToShow = 3;

        if(tabCount < 3) {
            slidesToShow = tabCount;
        }

        // Leader nav slider
        $(this).find('.slider-tabs-nav').addClass( 'slider-' + numSlick ).slick({
            arrows: false,
            asNavFor: '.slider-tabs',
            dots: false,
            focusOnSelect: true,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: slidesToShow,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

    });

})(jQuery);